// 登录相关

/**
 * @description [微信登录](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/LoginController/wxToken)
 * @param {Login.LoginTokenDTO} data - 表单数据
 */
export const postSysWxToken = (data: Login.LoginTokenDTO) => service.post<Res<string>>('/sys/wxToken', data)

/**
 * @description [设置微信名称头像](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/LoginController/setName)
 * @param {Login.LoginTokenDTO} data - 表单数据
 */
export const postSysSetName = (data: Login.LoginTokenDTO) => service.post<Res<boolean>>('/sys/setName', data)

/**
 * @description [退出登录](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/LoginController/loginout)
 */
export const postSysLoginout = () => service.post<Res<boolean>>('/sys/loginout')

/**
 * @description [微信通过code换取session_key接口的响应](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/LoginController/wxSession)
 * @param {object} params - 微信通过code换取session_key接口的响应
 * @param {string} params.code - code
 */
export const getSysWxSession = (params: {
  code: string
}) => service.get<Res<Login.WxMaJscode2SessionResult>>('/sys/wxSession', { params })

/**
 * @description [生成小程序码](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/LoginController/wxQrCode)
 * @param {object} params - 生成小程序码
 * @param {number} params.page - page
 * @param {string} params.key - key
 */
export const getSysWxQrCode = (params: {
  page: number
  key: string
}) => service.get<Res<string>>('/sys/wxQrCode', { params })

/**
 * @description [测试的token, 自己在后台账号里输入假的openId](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/LoginController/testToken)
 * @param {object} params - 测试的token, 自己在后台账号里输入假的openId
 * @param {string} params.openId - openId
 */
export const getSysTestToken = (params: {
  openId: string
}) => service.get<Res<string>>('/sys/testToken', { params })

/**
 * @description [Pc微信登录](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/LoginController/pcToken)
 * @param {object} params - Pc微信登录
 * @param {string} params.code - code
 */
export const getSysPcToken = (params: {
  code: string
}) => service.get<Res<string>>('/sys/pcToken', { params })

/**
 * @description [Pc登录地址](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/LoginController/pcQrCode)
 * @param {object} params - Pc登录地址
 * @param {string} params.redirectUrl - redirectUrl
 */
export const getSysPcQrCode = (params: {
  redirectUrl: string
}) => service.get<Res<string>>('/sys/pcQrCode', { params })

/**
 * @description [获取登录用户信息](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/LoginController/getInfo)
 */
export const getSysGetInfo = () => service.get<Res<Login.UserInfoVO>>('/sys/getInfo')
